import { render, staticRenderFns } from "./DriveFileForm.vue?vue&type=template&id=69886e78&scoped=true&lang=pug"
import script from "./DriveFileForm.vue?vue&type=script&lang=js"
export * from "./DriveFileForm.vue?vue&type=script&lang=js"
import style0 from "./DriveFileForm.vue?vue&type=style&index=0&id=69886e78&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69886e78",
  null
  
)

export default component.exports